/**
 * Utility function to parse markdown-style text with **bold** and *italics*
 * Converts "SAFE*Care*" to "SAFE<em>Care</em>"
 * Converts "**Bold Text**" to "<strong>Bold Text</strong>"
 */
export function parseMarkdownItalics(text) {
    if (!text) return text;

    // Handle branding specifically
    const brandPattern = /(SAFEC\+\+|SAFEC\+|SAFE\*Care\*|SAFECare\+)/g;

    // First split by bold markers (**text**)
    const boldParts = text.split(/(\*\*[^*]+\*\*)/g);

    return boldParts.flatMap((part, i) => {
        // Check if this part is bold
        const boldMatch = part.match(/^\*\*([^*]+)\*\*$/);
        if (boldMatch) {
            return <strong key={`b-${i}`}>{boldMatch[1]}</strong>;
        }

        // Check for brand matches in the non-bold part
        const brandParts = part.split(brandPattern);
        return brandParts.map((subPart, j) => {
            if (subPart === 'SAFEC+' || subPart === 'SAFEC++' || subPart === 'SAFE*Care*' || subPart === 'SAFECare+') {
                const plusCount = subPart.endsWith('++') ? 2 : (subPart.endsWith('+') ? 1 : 0);
                const isCareVersion = subPart.includes('Care');

                return (
                    <span key={`brand-${i}-${j}`} style={{
                        whiteSpace: 'nowrap',
                        fontWeight: 'bold',
                        display: 'inline-block', // Added to help with gradient issues
                        WebkitTextFillColor: 'initial' // Ensure gradient doesn't hide colors
                    }}>
                        SAFE{isCareVersion ? 'Care' : <em style={{ fontStyle: 'italic', fontWeight: 'bold', textTransform: 'none' }}>C</em>}
                        <span style={{ color: '#ef4444', fontWeight: '800' }}>
                            {Array(plusCount).fill('+').join('')}
                        </span>
                    </span>
                );
            }

            // If not brand, check for italics within this part
            if (subPart.includes('*')) {
                const italicParts = subPart.split(/(\*[^*]+\*)/g);
                return (
                    <span key={`it-${i}-${j}`}>
                        {italicParts.map((itPart, k) => {
                            const italicMatch = itPart.match(/^\*([^*]+)\*$/);
                            if (italicMatch) {
                                return <em key={`em-${i}-${j}-${k}`}>{italicMatch[1]}</em>;
                            }
                            return itPart;
                        })}
                    </span>
                );
            }

            return subPart;
        });
    });
}

/**
 * Safecare Brand Component
 * Displays "SAFEC+" with custom styling
 */
export default function SafecareBrand({ className = "" }) {
    return (
        <span className={className}>
            {parseMarkdownItalics("SAFEC+")}
        </span>
    );
}
